import * as types from '../actions/actionTypes';

const initialState = {
    profile: {
        success: true,
        loading: false,
        data: {}
    },
    permissions: {
        success: true,
        loading: false,
        data: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_USER_PROFILE:
            return Object.assign({}, state, { profile: { ...state.profile, loading: true } });
        case types.GET_USER_PROFILE:
            return Object.assign({}, state, { profile: action.response });

        case types.START_GET_USER_PERMISSIONS:
            return action.myPermissions ? Object.assign({}, state, { permissions: { ...state.permissions, loading: true } }) : state;
        case types.GET_USER_PERMISSIONS:
            return action.myPermissions ? Object.assign({}, state, { permissions: action.response }) : state;

        case types.UPDATE_USER_PROFILE:
            return Object.assign({}, state, { profile: { ...state.profile, data: { ...state.profile.data, ...action.update } } });

        case types.LOGOUT:
            return Object.assign({}, action.response.success ? initialState : state);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/UserProfileReducer.js